const configs = {
  'ai-radar': {
    title: 'AI 预警雷达', icon: '📡', ai: 'AI 主动检测频次、时间、区域和敏感语义异常，处置结果全程留痕。',
    columns: [['alert_level','级别'],['alert_type','异常类型'],['title','预警标题'],['analysis','AI 分析'],['status','状态'],['created_at','触发时间']],
    editable: [['alert_level','预警级别'],['alert_type','异常类型'],['title','标题'],['analysis','分析'],['status','状态']]
  },
  'ai-policy': {
    title: 'AI 政策情报官', icon: '📰', ai: '官方来源采集、AI 解读与行为指引推送；所有内容保留原始来源。',
    columns: [['title','政策标题'],['source_name','来源'],['publish_at','发布时间'],['ai_summary','AI 解读'],['status','状态']],
    editable: [['title','标题'],['source_name','来源'],['source_url','来源地址'],['publish_at','发布时间'],['content','正文'],['ai_summary','AI 解读'],['status','状态']]
  },
  'ai-insight': {
    title: 'AI 行为洞察', icon: '🔮', ai: '从过程行为识别覆盖盲区、能力分层和闭环风险，不生成个人销售指标。',
    columns: [['insight_type','洞察类型'],['period_code','周期'],['title','标题'],['content','AI 洞察'],['score','健康度']],
    editable: [['org_id','组织ID'],['insight_type','类型'],['period_code','周期'],['title','标题'],['content','内容'],['score','评分']]
  },
  terminal: {
    title: '终端信息库', icon: '🏥', ai: '省区 → 医院 → 科室 → 医生四级主数据，为 AI 匹配提供唯一可信 ID。',
    columns: [['hospital_code','医院编码'],['hospital_name','医院'],['hospital_level','等级'],['address','地址'],['status','状态']],
    editable: [['region_id','地区ID'],['hospital_code','医院编码'],['hospital_name','医院名称'],['hospital_level','医院等级'],['address','地址'],['longitude','经度'],['latitude','纬度'],['status','状态']]
  },
  org: {
    title: '人员组织库', icon: '👥', ai: '维护组织、人员、角色与备案状态；新建账号初始密码为 sj123456。',
    columns: [['user_code','人员编码'],['display_name','姓名'],['login_name','登录账号'],['mobile','手机号'],['status','状态']],
    editable: [['org_id','组织ID'],['user_code','人员编码'],['login_name','登录账号'],['display_name','姓名'],['mobile','手机号'],['status','状态']]
  },
  product: {
    title: '产品信息库', icon: '💊', ai: '产品说明书、适应症和授权范围是合规判断的实时事实来源。',
    columns: [['product_code','产品编码'],['product_name','产品名称'],['generic_name','通用名'],['indication','适应症'],['status','状态']],
    editable: [['product_code','产品编码'],['product_name','产品名称'],['generic_name','通用名'],['indication','适应症'],['adverse_reaction','不良反应'],['contraindication','禁忌症'],['status','状态']]
  },
  plan: {
    title: '医生排班管理', icon: '🗓️', ai: '维护医生基础上班时间、请假和临时调整，数据同步用于移动端AI排程。', readonly: true
  },
  visit: {
    title: '拜访记录', icon: '📝', ai: '列表展示拜访状态与合规结论；详情展示拜访信息、定位与合规历史。', readonly: true,
    columns: [['visit_no','拜访编号'],['visit_time','时间'],['submitted_region_name','省区'],['hospital_name','医院'],['department_name','科室'],['doctor_name','医生'],['visit_method','方式'],['participants','参与代表'],['has_feedback_issue','有反馈'],['gps_status','GPS 定位'],['status','状态'],['compliance_status','合规'],['compliance_fail_summary','失败原因']],
    editable: [['hospital_id','医院ID'],['department_id','科室ID'],['doctor_id','医生ID'],['product_id','产品ID'],['visit_method','方式'],['visit_time','时间'],['visit_content','内容'],['status','状态']]
  },
  meeting: {
    title: '科室会记录', icon: '🎤', ai: '集中查看会议主题、讲者、参加人员、AI 纪要和录音识别原文。', statusFilter: false,
    columns: [['subject','会议主题'],['meeting_time','会议时间'],['location','会议地点'],['speaker_name','讲者'],['participant_names','参加人']],
    editable: [['hospital_id','医院ID'],['department_id','科室ID'],['subject','会议主题'],['meeting_time','会议时间'],['location','地点'],['speaker_name','讲者'],['attendee_count','人数'],['minutes_text','纪要']]
  },
  training: {
    title: '培训学习', icon: '📚', ai: '结合人员薄弱项推荐微课，并记录学习进度和考试结果。',
    columns: [['title','培训主题'],['training_type','形式'],['start_at','开始'],['end_at','结束'],['pass_score','合格分'],['status','状态']],
    editable: [['title','标题'],['training_type','形式'],['content','内容'],['start_at','开始时间'],['end_at','结束时间'],['pass_score','合格分'],['status','状态']]
  },
  feedback: {
    title: '客户反馈', icon: '💬', ai: 'APP 统一采集反馈正文，PC 人工确认类型、紧急度和协同部门。',
    columns: [['reporter_name','来源'],['feedback_type_name','反馈类型'],['content','反馈内容'],['urgency','紧急度'],['collaboration_department_name','协同部门'],['status','状态'],['created_at','反馈时间']],
    readonly: true
  },
  compliance: {
    title: '合规校验', icon: '🛡️', ai: '四项结果只使用 PASS/FAIL；每一轮按 check_seq 追加保存，历史不可覆盖。',
    columns: [['check_seq','轮次'],['check_name','校验项'],['check_status','结果'],['fail_reason','失败原因'],['rule_reference','依据'],['created_at','时间']],
    readonly: true
  },
  audit: {
    title: '日志中心', icon: '📋', ai: '关键行为、AI 调用、状态变更和人工确认均可按对象追溯。',
    columns: [['created_at','时间'],['operator_name','操作人'],['action_code','操作'],['object_type','对象类型'],['object_id','对象ID'],['change_summary','摘要']],
    readonly: true
  },
  'ai-assistant': {
    title: 'AI 合规助手', icon: '💬', ai: '基于合规知识库的问答入口。Mock 环境提供确定性示例，生产环境禁止模拟输出。',
    columns: [['call_type','调用类型'],['provider_code','供应商'],['request_summary','请求摘要'],['response_summary','响应摘要'],['success','结果'],['created_at','时间']],
    readonly: true
  }
}

export default configs
